export default "__VITE_ASSET__BJOuyeFi__"